import { useQuery } from '@apollo/client';

import { marketplaceClient } from '@uptime/controller/src/apolloClientConfiguration';
import { CONFIRMED_STATUS } from '@uptime/shared/constants/statuses';
import { userClient as client } from '@uptime/shared/graphql/apolloClientConfiguration';
import { getServiceProvider } from '@uptime/shared/graphql/marketplace';
import { getAccountProfile, getBusinessProfile } from '@uptime/shared/graphql/users';

const useServiceProviderInfo = (userId, technicianUserId, operations = {}) => {
  const { shouldSkipAccount = false, shouldSkipSP = false } = operations;
  const {
    loading,
    data: { profile = {} } = {},
    error,
  } = useQuery(getAccountProfile, {
    variables: {
      userId: technicianUserId,
    },
    client,
    skip: shouldSkipAccount,
  });

  const accountId = profile?.accountId;

  const {
    loading: businessProfileLoading,
    data: { businessProfile = {} } = {},
    error: businessProfileError,
  } = useQuery(getBusinessProfile, {
    variables: {
      accountId,
    },
    client,
    skip: shouldSkipAccount || !accountId,
  });

  const {
    loading: serviceProviderIsLoading,
    data: { serviceProvider } = {},
    error: serviceProviderError,
  } = useQuery(getServiceProvider, {
    variables: {
      userId,
      technicianUserId,
    },
    client: marketplaceClient,
    fetchPolicy: 'no-cache',
    skip: shouldSkipSP,
  });

  return {
    isLoading: loading || serviceProviderIsLoading || businessProfileLoading,
    isError: Boolean(error || serviceProviderError || businessProfileError),
    profile,
    businessProfile,
    isExistingInSPList: serviceProvider && serviceProvider.status === CONFIRMED_STATUS,
  };
};

export default useServiceProviderInfo;
